export default __webpack_public_path__ + "static/media/mw8.16dd2487.webp";